import {createAction} from 'redux-actions';
import compileSymbols from '~/utils/compileSymbols';
import RemoteServices from '~/constants/RemoteServices';
import MMSClient from 'mms_client_js';
import {
  getAnchorStyleId,
  isAnchorComplementsLoaded,
  getStyleAlternatives
} from '~/selectors/ProductSelectors';
import {
  getStyle,
  isFetchingStyleComplements
} from '~/selectors/CatalogSelectors';
import {loadStyles} from '~/actions/CatalogActions';

const mms = new MMSClient(`${RemoteServices.products}/api/out`);

export const types = compileSymbols(
  [
    'FETCH',
    'SET_IS_FETCHING',
    'FETCH_SUCCESS',
    'FETCH_ERROR',
    'ALTERNATIVES_FETCH_SUCCESS'
  ],
  'complements'
);

const fetchComplements = createAction(types.FETCH);
const setIsFetchingComplements = createAction(types.SET_IS_FETCHING);
const complementsSuccess = createAction(types.FETCH_SUCCESS);
const complementsError = createAction(types.FETCH_ERROR);
const alternativesSuccess = createAction(types.ALTERNATIVES_FETCH_SUCCESS);

export const loadAlternatives = styleId => (dispatch, getState) => {
  const state = getState();
  const loadedAlternativeStyleIds = getStyleAlternatives(state)(styleId);

  if (loadedAlternativeStyleIds) {
    const unloadedAlternativeStyleIds = loadedAlternativeStyleIds.filter(
      styleId => {
        return !getStyle(state, {styleId});
      }
    );

    if (unloadedAlternativeStyleIds.length > 0) {
      dispatch(loadStyles(unloadedAlternativeStyleIds));
    }
  } else {
    return mms.getStyleComplements(styleId).then(data => {
      if (data.alternatives.length > 0) {
        dispatch(
          alternativesSuccess({alternativeIds: data.alternatives, styleId})
        );
        const unloadedAlternativeStyleIds = data.alternatives.filter(
          styleId => {
            return !getStyle(state, {styleId});
          }
        );
        if (unloadedAlternativeStyleIds.length > 0) {
          dispatch(loadStyles(unloadedAlternativeStyleIds));
        }
      }
    });
  }
};

export function loadAnchorComplements() {
  return (dispatch, getState) => {
    const state = getState();
    if (!isAnchorComplementsLoaded(state)) {
      const styleId = getAnchorStyleId(state);
      loadComplements(styleId)(dispatch, getState);
    }
  };
}

export const loadComplements = styleId => (dispatch, getState) => {
  if (isFetchingStyleComplements(getState?.(), {styleId})) return;

  dispatch(setIsFetchingComplements({styleId, fetching: true}));
  dispatch(fetchComplements(styleId));

  return mms.getStyleComplements(styleId).then(
    data => {
      dispatch(complementsSuccess(data));
      dispatch(setIsFetchingComplements({styleId, fetching: false}));
      dispatch(loadStyles(data.complements));
    },
    err => {
      err.styleId = styleId;
      dispatch(setIsFetchingComplements({styleId, fetching: false}));
      return dispatch(complementsError(err));
    }
  );
};
